import { isDefined } from "@clipboard-health/util-ts";
import { Stack, type SxProps, type Theme } from "@mui/material";

import { BoostedPayLabel } from "./BoostedPayLabel";
import { HourlyPayLabel } from "./HourlyPayLabel";
import { TotalPayLabel } from "./TotalPayLabel";

export interface PayInfoLabelProps {
  /**
   * The formatted total pay for the shift.
   */
  totalPay: string | undefined;
  /**
   * The formatted hourly pay for the shift.
   */
  hourlyPay: string | undefined;
  /**
   * Whether the pay data is being fetched.
   */
  isLoading?: boolean;
  /**
   * Custom styles to apply to the component.
   */
  wrapperSx?: SxProps<Theme>;
  /**
   * The formatted shift boost pay for the shift.
   */
  totalWithBoostPay?: string | undefined;
}

/**
 * @deprecated Use PayInfoLabel instead
 * It has column layout, which is a new way to display pay info label
 */
export function PayInfoLabelDeprecated(props: PayInfoLabelProps) {
  const { totalPay, hourlyPay, totalWithBoostPay, isLoading, wrapperSx } = props;

  return (
    <Stack spacing={3} direction="row" alignItems="center" sx={wrapperSx}>
      {isDefined(totalWithBoostPay) ? (
        <BoostedPayLabel
          size="medium"
          totalPayBeforeBoost={totalPay}
          totalWithBoostPay={totalWithBoostPay}
          includePayBeforeBoost={false}
        />
      ) : (
        <TotalPayLabel
          size="medium"
          totalPay={totalPay}
          isLoading={isLoading}
          sx={(theme) => ({ color: theme.palette.text.tertiary })}
        />
      )}

      <HourlyPayLabel hourlyPay={hourlyPay} isLoading={isLoading} size="medium" />
    </Stack>
  );
}
